import yup from 'utils/yup';

export const validationSchema = yup.object().shape({
  title: yup.string().trim().required(),
  primaryColor: yup.string().nullable().hex(),
});

export const tourRequestValidationSchema = validationSchema.shape({
  tourRequest: yup.object().shape({
    id: yup.string().required(),
  }),
});
